import { Box, Chip, Fade } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import SortableItem from '../../components/DragAndDrop/SortableItem';
import {
  SortableItemContextProvider,
  useSortableItemContext,
} from '../../components/DragAndDrop/SortableItemContext';
import { IMedia } from '../../lib/MediasLib';
import MediaCard, { MediaCardProps } from './MediaCard';

const useStyles = makeStyles()(() => ({
  mediaLegend: {
    left: 8,
    bottom: 8,
    position: 'absolute',
  },
}));

interface MediaSortableCardProps extends MediaCardProps {
  mediaId: string;
  legend?: string;
  onRemoveClick: (media: IMedia) => void;
  isDragged: boolean;
}

const MediaSortableCard = ({ legend, options, media, onRemoveClick }: MediaSortableCardProps) => {
  const { classes } = useStyles();
  const { elementProps } = useSortableItemContext();
  return (
    <Box
      sx={{
        position: 'relative',
        flexShrink: 0,
      }}
    >
      <MediaCard
        options={options}
        onRemoveClick={onRemoveClick}
        media={media}
        dragHandleProps={{
          ...elementProps.attributes,
          ...elementProps.listeners,
        }}
      />
      <Fade in={!!legend}>
        <Chip size="small" className={classes.mediaLegend} label={legend} />
      </Fade>
    </Box>
  );
};

const MediaSortableCardContainer = (props: MediaSortableCardProps) => {
  return (
    <SortableItemContextProvider id={props.mediaId}>
      <SortableItem key={props.mediaId} isDragged={props.isDragged}>
        <MediaSortableCard {...props} />
      </SortableItem>
    </SortableItemContextProvider>
  );
};

export default MediaSortableCardContainer;
